import { render, staticRenderFns } from "./myMerchantPaymentsComponent.vue?vue&type=template&id=be337716&"
import script from "./myMerchantPaymentsComponent.vue?vue&type=script&lang=js&"
export * from "./myMerchantPaymentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports